import { domIsReady } from "./utils.js"

export let elementClass = 'reveal'
export let delay = 100
export let threshold = 0.2

async function init() {
  await domIsReady()
  revealItemsSetup()
}

function revealItemsSetup() {
  const items = Array.from(document.querySelectorAll(`.${elementClass}:not([data-reveal-active="1"])`))

  const intObserver = new IntersectionObserver((entries) => {
    entries
      .filter(entry => entry.isIntersecting)
      .forEach(entry => {
        if (delay) {
          setTimeout(() => {
            entry.target.dataset.revealActive = 1
          }, Math.random() * delay)
        }
        else {
          entry.target.dataset.revealActive = 1
        }
      })
  }, {
    threshold: 0.2
  })

  items.forEach(el => intObserver.observe(el))
}

init()
